import { ProductOrBrand } from "./alternativeTypes";

export const hardwareProducts: ProductOrBrand[] = [
  {
    name: "DeWalt",
    ownerCountry: "US",
    categories: ["hardware", "power-tools"]
  },
  {
    name: "Skil",
    ownerCountry: "CN",
    headquarterIn: "US",
    categories: ["hardware", "power-tools", "tools"]
  },
  {
    name: "Oregon", // Or Oregon Tool
    ownerCountry: "US",
    categories: ["hardware", "power-tools"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Oregon_Tool"]
  },   
  {
    name: "Black+Decker",
    ownerCountry: "US",
    categories: ["hardware", "appliances", "small-appliances", "power-tools", "gardening"]
  },
  {
    name: "Stanley",
    ownerCountry: "US",
    categories: ["hardware", "tools"]
  },
  {
    name: "Bahco",
    ownerCountry: "US", // Snap-on
    categories: ["hardware", "tools"]
  },

  {
    name: "Makita",
    ownerCountry: "JP",
    categories: ["hardware", "power-tools", "tools"]
  },

  // No need to mention Kärcher high pressure wascher, because there are no US competitors

  {
    name: "Hultafors",
    ownerCountry: "SE",
    categories: ["hardware", "tools"],
    sourceLinks: ["https://hultafors.com/no-no", "https://sv.wikipedia.org/wiki/Investment_AB_Latour"]
  },

  {
    name: "Bosch",
    ownerCountry: "DE",
    categories: ["hardware", "power-tools", "tools"],
  },
  {
    name: "Stiga",
    ownerCountry: "IT",
    categories: ["hardware", "power-tools"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Stiga"]
  },
  {
    name: "Far Tools",
    ownerCountry: "FR",
    availableIn: ["BE", "FR", "ES", "PT", "IT", "RO", "BG", "EE", "IS"],
    categories: ["hardware", "power-tools", "tools"],
    sourceLinks: ["https://www.fartools.com/en/article/who-are-we.html"]
  },
  {
    name: "Scheppach",
    ownerCountry: "DE",
    categories: ["hardware", "power-tools"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Scheppach_(company)"]
  },    
  {
    name: "Dremel",
    ownerCountry: "DE", // Bosch
    categories: ["hardware", "tools"],
  },
  {
    name: "Cocraft",
    include: false, // Mostly made in China
    ownerCountry: "SE", // Clas Ohlson
    categories: ["hardware", "tools"],
  },
  {
    name: "Probuilder",
    ownerCountry: "DK", // Schou Company A/S
    categories: ["hardware", "tools"],
  },
  {
    name: "Wisent",
    ownerCountry: "DE", // Flensburger Fahrzeugbau
    categories: ["hardware", "tools"],
  },
  {
    name: "Bauhaus",
    ownerCountry: "DE",
    categories: ["hardware", "tools"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Bauhaus_(company)"],
  },
  {
    name: "Festool",
    ownerCountry: "DE",
    categories: ["hardware", "power-tools"],
  },
  {
    name: "Stihl",
    ownerCountry: "DE",
    categories: ["hardware", "power-tools"],
  },
  {
    name: "Draper",
    ownerCountry: "UK",
    categories: ["hardware", "tools"],
  },
  {
    name: "Gardena",
    ownerCountry: "SE",
    headquarterIn: "DE",
    categories: ["hardware", "gardening"],
  },
  {
    name: "Husqvarna",
    ownerCountry: "SE",
    categories: ["hardware", "gardening"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Husqvarna_Group"]
  },
  
]

export const heavyMachineryProducts: ProductOrBrand[] = [

  {
    name: "John Deere",
    ownerCountry: "US",
    categories: ["heavy-machinery"],
    sourceLinks: ["https://www.felleskjopet.no/maskin"]
  },
  {
    name: "Fendt",
    ownerCountry: "US", // Owned by AGCO
    headquarterIn: "DE",
    categories: ["heavy-machinery"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Fendt"]
  },
  {
    name: "Valtra",
    ownerCountry: "US", // Owned by AGCO
    headquarterIn: "FI",
    categories: ["heavy-machinery"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Valtra"]
  },
  {
    name: "Massey Ferguson",
    ownerCountry: "US", // Owned by AGCO
    categories: ["heavy-machinery"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Massey_Ferguson"]
  },
  {
    name: "Claas",
    ownerCountry: "DE",
    categories: ["heavy-machinery"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Claas"]
  },
  {
    name: "Deutz-Fahr",
    ownerCountry: "IT",
    headquarterIn: "DE",
    categories: ["heavy-machinery"],
    sourceLinks: ["https://en.wikipedia.org/wiki/SDF_Group"]
  },
  {
    name: "New Holland",
    ownerCountry: "IT",
    headquarterIn: "IT",
    categories: ["heavy-machinery"],
    sourceLinks: ["https://en.wikipedia.org/wiki/CNH_Industrial"]
  },
  {
    name: "Case IH",
    ownerCountry: "IT",
    headquarterIn: "US",
    categories: ["heavy-machinery"],
    sourceLinks: ["https://en.wikipedia.org/wiki/CNH_Industrial"]
  },
]